import { render, staticRenderFns } from "./dbcheck.vue?vue&type=template&id=3062ca3d&scoped=true&"
import script from "./dbcheck.vue?vue&type=script&lang=js&"
export * from "./dbcheck.vue?vue&type=script&lang=js&"
import style0 from "./dbcheck.vue?vue&type=style&index=0&id=3062ca3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062ca3d",
  null
  
)

export default component.exports